import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Contributor = ({
  // eslint-disable-next-line camelcase
  slug, first_name, last_name, organisation, profile_picture_url, isCompanyProfile,
}) => {
  const url = `/contributors/${slug}`;
  // eslint-disable-next-line camelcase
  const imgUrl = profile_picture_url || window.getLivewireAssetPath('avatar-fallback.png');
  // eslint-disable-next-line camelcase
  const fullName = `${first_name}${last_name ? (` ${last_name}`) : ''}`;
  const showCompanyName = isCompanyProfile && !!organisation;

  const Figure = styled.figure`
    display: flex;

    > a {
      flex-shrink: 0;
    }

    > figcaption > a.following-contributor-name {
      width: max-content;
    }
  `;

  return (
    <Figure>
      <a href={url}>
        <img src={imgUrl} alt={fullName} />
      </a>
      <figcaption>
        <a className="following-contributor-name" href={url}>{showCompanyName ? organisation : fullName}</a>
        {!showCompanyName
          && <a className="following-contributor-organization" href={url}>{organisation}</a>}
      </figcaption>
    </Figure>
  );
};

Contributor.propTypes = {
  slug: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string,
  organisation: PropTypes.string,
  profile_picture_url: PropTypes.string,
  isCompanyProfile: PropTypes.bool,
};

Contributor.defaultProps = {
  last_name: null,
  organisation: null,
  profile_picture_url: null,
  isCompanyProfile: false,
};

export default function Following({ contributors }) {
  return (
    <aside className="sidebar-item sidebar-who-are-you-following">
      <h2 className="header">
        {'Who you\'re '}
        <span>following</span>
      </h2>
      {!!contributors.length && (
        <ul>
          {contributors.map(c => <Contributor {...c} key={c.slug} />)}
        </ul>
      )}
      {!contributors.length && <p>You are not following any contributors</p>}
      <hr />
      <a href="/alerts/contributors">View all</a>
    </aside>
  );
}

Following.propTypes = {
  contributors: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
  })).isRequired,
};
